import { render, staticRenderFns } from "./CallAutoType2.vue?vue&type=template&id=427965da"
import script from "./CallAutoType2.vue?vue&type=script&lang=js"
export * from "./CallAutoType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports